var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('AppHeader'),(_vm.hasOrganisationAccess && !_vm.hideFeedback)?_c('review-component'):_vm._e(),_c('router-view'),(!_vm.hideFooter)?_c('div',{staticClass:"foot-logo"},[_vm._m(0)]):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":require("@/assets/img/okkuLogo.png"),"height":"30px","alt":""}})])
}]

export { render, staticRenderFns }